<template>
  <div class="product-baby-item">
    <!-- ** Baby Mat Start ** -->
    <div class="baby-mat">
      <b-row class="mat">
        <b-col lg="" class="mat__content">
          <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
            <span>{{$t('baby.mat.title')}}</span>
          </div>
          <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
            <span v-html="$t('baby.mat.sub-title')"></span>
            <span class="sub-title__exp">{{$t('baby.mat.sub-title-exp')}}</span>
          </div>

          <b-row class="content__info">
            <b-col class="info__item" cols="12" data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_move.png" alt="move"/>
              <span>{{$t('baby.mat.movement')}}</span>
            </b-col>
            <b-col class="info__item" cols="12" data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_breathe.png" alt="breathe"/>
              <span>{{$t('baby.mat.breathe')}}</span>
            </b-col>
            <b-col class="info__item" cols="12" data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_heartrate.png" alt="heartrate"/>
              <span>{{$t('baby.mat.heartrate')}}</span>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="auto" class="mat__image"
               data-aos="fade-up" :data-aos-duration="duration"
               data-aos-delay="300">
          <div>
            <img src="../../assets/img/img_baby_mat_1.png" alt="mat"/>
            <img src="../../assets/img/img_baby_mat_2.png" alt="mat"/>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- ** Baby Mat End ** -->

    <!-- ** Baby Light Start ** -->
    <div class="baby-light">
      <div class="light__content">
        <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
          <span>{{$t('baby.light.title')}}</span>
        </div>
        <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
          <span v-html="$t('baby.light.sub-title')"></span>
          <span class="sub-title__exp">{{$t('baby.light.sub-title-exp')}}</span>
        </div>
      </div>
      <b-row class="light">
        <b-col lg="" class="light__content">
          <b-row class="content__info">
            <b-col class="info__item" cols="6"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_light.png" alt="light"/>
              <span>{{$t('baby.light.light')}}</span>
            </b-col>
            <b-col class="info__item" cols="6"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_warning.png" alt="warning"/>
              <span>{{$t('baby.light.warning')}}</span>
            </b-col>
            <b-col class="info__item" cols="6"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_temp.png" alt="temp"/>
              <span>{{$t('baby.light.temperature')}}</span>
            </b-col>
            <b-col class="info__item" cols="6"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_humidity.png" alt="humidity"/>
              <span>{{$t('baby.light.humidity')}}</span>
            </b-col>
            <b-col class="info__item" cols="6"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_co2.png" alt="co2"/>
              <span v-html="$t('baby.light.co2')"></span>
            </b-col>
            <b-col class="info__item" cols="6"
                   data-aos="fade-up" :data-aos-duration="duration">
              <img src="../../assets/img/ic_baby_tvoc.png" alt="tvoc"/>
              <span>{{$t('baby.light.tvoc')}}</span>
            </b-col>
          </b-row>
        </b-col>

        <!-- ** Baby Light Image Start ** -->
        <b-col cols="12" lg="auto" class="light__image"
               data-aos="fade-up" :data-aos-duration="duration">
          <b-carousel
            class="image__carousel"
            no-animation :interval="1700" no-hover-pause
            img-width="944" img-height="720">
            <b-carousel-slide
              :img-src="`${require('../../assets/img/img_baby_light_off.png')}`"/>
            <b-carousel-slide
              :img-src="`${require('../../assets/img/img_baby_light_emergency.png')}`"/>
          </b-carousel>
        </b-col>
        <!-- ** Baby Light Image End ** -->
      </b-row>
    </div>
    <!-- ** Baby Light End ** -->
  </div>
</template>

<script>
import { FadeUpMixin } from '../mixins/FadeUp';

export default {
  name: 'BabyMatLight',
  data() {
    return {
    };
  },
  mixins: [FadeUpMixin],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/constant';
  @import '../../assets/scss/mixins';

  /* ------------------
    :: Product Baby CSS
    ------------------ */
  .product-baby-item {
    @include flexbox;
    @include flex-direction(column);
    align-items: center;
    padding: 122px 40px 148px;
    & > div {
      width: 100%;
      max-width: 1518px;
    }
    .content {
      &__title {
        color: $color-pink;
      }
      &__info {
        font-size: 16px;
      }
    }
    .info__item {
      @include flexbox;
      @include flex-direction(row);
      @include align-items(center);
      padding: 0;
      & > img {
        width: 60px;
        height: 60px;
      }
      & > span {
        word-break: break-all;
      }
    }
  }
  @media (min-width: 648px) {
    .product-baby-item {
      padding: 184px 40px 148px;
      .content {
        &__info {
          font-size: 20px;
        }
      }
      .info__item {
        & > img {
          width: 100px;
          height: 100px;
        }
      }
    }
  }

  /* ------------------
    :: Baby Mat CSS
    ------------------ */
  .baby-mat {
    flex-shrink: 0;
  }
  .mat {
    &__content {
      max-width: 640px;
      padding: 0;
    }
    &__image {
      padding: 0;
      flex: 0 0 100%;
      &> div{
        width: 100%;
        position: relative;
        margin-bottom: 100px;

        @include flexbox;
        @include flex-direction(column);
        @include align-items(flex-end);
        flex-shrink: 0;

        & > img {
          width: 100%;
          max-width: 1020px;
          height: auto;
          flex-shrink: 0;
        }

        & > img:last-of-type {
          animation: matFadeIn 0.5s infinite alternate;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
  }
  @media (min-width: 992px) {
    .mat {
      &__image {
        flex: 1;
        &> div{
          margin-top: 105px;
          margin-bottom: 0;
          min-height: 700px;
        }
      }
    }
  }

  /* ------------------
    :: Mat Animation CSS
    ------------------ */
  @keyframes matFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @-webkit-keyframes matFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* ------------------
    :: Baby Light CSS
    ------------------ */
  .baby-light {
    flex-shrink: 0;
  }
  .light {
    &__content {
      padding: 0;
      max-width: 820px;
    }
    &__image {
      padding: 0;
      flex: 0 0 100%;
      & > div {
        width: 100%;
        position: relative;
        margin-top: 0;
      }
    }
  }
  @media (min-width: 992px) {
    .light {
      &__image {
        flex: 1;
      }
    }
  }
</style>
